// extracted by mini-css-extract-plugin
export var searchHeader = "_98-0";
export var searchHeaderDark = "_98-1";